<template>
  <div>
    <top-message />
    <div class="content">
      <div>
        <el-form
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
          style="padding: 20px 30px 0"
        >
          <el-form-item label="申请状态">
            <el-select
              v-model="searchForm.auditStatus"
              placeholder="请选择"
              style="width: 120px"
              clearable
            >
              <el-option
                v-for="item in statusOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              style="width: 200px;"
              placeholder="请输入被授权单位企业信用代码"
              v-model="searchForm.enterpriseCode"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              style="width: 200px;"
              placeholder="请输入企业名称统一社会信用代码"
              v-model="searchForm.licenseCode"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="padding: 0">
        <el-table :data="tableData" style="width: 100%;">
          <el-table-column :show-overflow-tooltip="true" prop="enterpriseName" label="企业名称">
            <template slot-scope="{ row }">
              <span>{{ row.enterpriseName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="enterpriseCode" label="企业统一社会信用代码">
            <template slot-scope="{ row }">
              <span>{{ row.enterpriseCode }}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="licenseCode" label="被授权单位统一社会信用代码">
            <template slot-scope="{ row }">
              <!-- <span>{{ $moment(row.createTime).format('YYYY-MM-DD HH:mm')}}</span> -->
              <span>{{row.licenseCode}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="licenseTime" label="授权起止时间">
            <template slot-scope="{ row }">
              <span>{{ row.licenseTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="licenseNum" label="授权查询次数">
            <template slot-scope="{ row }">
              <span>{{ row.licenseNum }}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="licenseId" label="授权协议标识">
            <template slot-scope="{ row }">
              <span>{{ row.licenseId }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="optionTime" label="操作时间">
            <template slot-scope="{ row }">
              <span>{{ row.optionTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="auditStatus" label="审核状态">
            <template slot-scope="{ row }">
              <span>{{ row.auditStatus==1?'已同意':row.auditStatus==3?'已撤销':row.auditStatus==4?'已上报':'' }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="money" label="操作">
            <template slot-scope="{ row }">
              <el-button @click="detailLook(row)" type="text">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="text-align: right; margin-top:30px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40,50]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="cuntTotal"
        ></el-pagination>
      </div>
    </div>
    <!-- 详情 -->
    <div>
      <el-dialog
        title="企业授权协议详情"
        @close="detailCloseDialog"
        :visible.sync="dialogVisible"
        width="60%"
      >
        <div>
          <div>
            <span class="lines"></span>
            <span>基本信息</span>
            <div>
              <el-form label-width="200px">
                <el-form-item label="企业名称:">{{detailValue.enterprise_name }}</el-form-item>
                <el-form-item label="企业统一社会信用代码:">
                  <span>{{ detailValue.enterprise_code }}</span>
                </el-form-item>
                <el-form-item label="授权查询信息列表:">
                  <span>{{ detailValue.license_list }}</span>
                </el-form-item>
                <el-form-item label="被授权单位名称:">
                  <span>{{ detailValue.license_name }}</span>
                </el-form-item>
                <el-form-item label="被授权单位统一社会信用代码:">
                  <span>{{ detailValue.license_code }}</span>
                </el-form-item>
                <el-form-item label="授权起止时间:">
                  <span>{{ detailValue.license_time }}</span>
                </el-form-item>
                <el-form-item label="授权查询次数:">
                  <span>
                    {{ detailValue.license_num
                    }}
                  </span>
                </el-form-item>
                <el-form-item
                  label="贷款阶段:"
                >{{ detailValue.loan_period==1?'贷前':detailValue.loan_period==2?'贷后':detailValue.loan_period==3?'不限':''}}</el-form-item>
                <el-form-item
                  label="状态:"
                >{{ detailValue.auditStatus==0?'未审批':detailValue.auditStatus==1?'已同意':detailValue.auditStatus==2?'已拒绝':detailValue.auditStatus==3?'已撤销':detailValue.auditStatus==4?'已上传':'' }}</el-form-item>
                <el-form-item label="授权协议标识:">
                  <span>{{ detailValue.license_id }}</span>
                </el-form-item>
              </el-form>
            </div>
          </div>

          <div>
            <span class="lines"></span>
            <span>附件信息</span>
            <p @click="downPdf">{{ detailValue.attachment }}</p>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { authMangList, authMangDetail } from "../../api/authmanget";
import TopMessage from "@/components/TopMessage";
export default {
  components: { TopMessage },
  data() {
    return {
      dialogVisible: false,
      searchForm: {
        enterpriseCode: "",
        licenseCode: "",
        auditStatus: "",
        page: 1,
        pageSize: 10
      },
      creaTime: [],
      cuntTotal: 0,
      statusOption: [
        {
          label: "已同意",
          value: "1"
        },
        {
          label: "已撤销",
          value: "3"
        },
        {
          label: "已上传",
          value: "4"
        }
      ],
      tableData: [],
      detailValue: {}
    };
  },
  mounted() {
    this.authMangListApi();
  },
  computed: {
    organization: function() {
      return this.$store.getters.organization;
    }
  },
  methods: {
    // 搜索
    onSubmit() {
      this.authMangListApi();
    },
    // 列表接口数据
    async authMangListApi() {
      const res = await authMangList({
        ...this.searchForm,
        organization: this.organization
      });
      this.tableData = res.data.data;
      this.cuntTotal = res.data.pageInfo.total;
    },

    // 详情接口
    async authMangDetailApi(id) {
      const res = await authMangDetail({ id });
      this.detailValue = res.data.data;
      console.log(res, "详情");
    },
    // 详情
    detailLook(row) {
      this.dialogVisible = true;
      this.authMangDetailApi(row.id);
    },
    detailCloseDialog() {
      this.dialogVisible = false;
    },
    //详情下载
    downPdf() {
      // 编码转译
      const filname = this.detailValue.attachment;
      const encodedPath = encodeURIComponent(filname);
      const xhr = new XMLHttpRequest();
      xhr.open(
        "get",
        this.baseUrl +
          `/api/v1/bankLicense/downloadFile?fileName=${encodedPath}`,
        true
      ); // get、post都可
      xhr.responseType = "blob"; // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = filname;
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send();
    },

    // 分页
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.authMangListApi(this.searchForm);
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.authMangListApi(this.searchForm);
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  min-height: 787px;
  background: #fff;
  box-sizing: border-box;
  padding-top: 20px;
  font-size: 14px;
  border-radius: 6px;
  margin-top: 20px;
}
.lines {
  width: 3px;
  height: 15px;
  background: #0081cc;
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
}
</style>